export const blockIconsUiactionsAddCircleNew = (
	<span className='material-symbols-outlined'>add_circle</span>
);
